import React from 'react';

import { createClassName } from 'utils/createClassName';

import './dashboardHeaderLayoutStyles.scss';

type Props = {
  logo: React.ReactNode;
  navigationControls: React.ReactNode;
  accountControls: React.ReactNode;
};

export const DashboardHeaderLayoutComponent = (props: Props) => {
  const { logo, navigationControls, accountControls } = props;

  const createdashboardHeaderLayoutClassName = createClassName(
    'dashboardHeaderLayout'
  );

  const wrapperClassName = createdashboardHeaderLayoutClassName('wrapper');

  const leftItemsClassName = createdashboardHeaderLayoutClassName('leftItems');

  const rightItemsClassName = createdashboardHeaderLayoutClassName(
    'rightItems'
  );

  const logoClassName = createdashboardHeaderLayoutClassName('logo');

  const navigationControlsClassName = createdashboardHeaderLayoutClassName(
    'navigationControls'
  );

  const accountControlsClassName = createdashboardHeaderLayoutClassName(
    'accountControls'
  );

  return (
    <div className={wrapperClassName}>
      <div className={leftItemsClassName}>
        <div className={logoClassName}>{logo}</div>
        <div className={navigationControlsClassName}>{navigationControls}</div>
      </div>
      <div className={rightItemsClassName}>
        <div className={accountControlsClassName}>{accountControls}</div>
      </div>
    </div>
  );
};
